import { Component, Input, signal } from '@angular/core';

/**
 * Eye button that shows/hides a password <input>. Flips the referenced input's
 * `type` directly, so the host page needs no state of its own. Place it next to
 * the input inside a `relative` wrapper (the button is absolutely positioned on
 * the right) and give the input enough right padding (e.g. `pr-9`).
 *
 *   <div class="relative">
 *     <input #pwd type="password" class="... pr-9">
 *     <password-toggle [input]="pwd" />
 *   </div>
 */
@Component({
  selector: 'password-toggle',
  template: `
    <button type="button" tabindex="-1" (click)="toggle()"
      [attr.aria-label]="visible() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
      [title]="visible() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
      class="absolute inset-y-0 right-0 flex items-center px-2.5 text-slate-400 hover:text-slate-700 cursor-pointer">
      @if (visible()) {
      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
      </svg>
      } @else {
      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
      }
    </button>
  `,
})
export class PasswordToggleComponent {
  @Input({ required: true }) input!: HTMLInputElement;

  visible = signal(false);

  toggle() {
    this.visible.set(!this.visible());
    this.input.type = this.visible() ? 'text' : 'password';
  }
}
